// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Button } from "@hex-insights/core";
import {
	AddSubFormButtonRenderProps,
	BooleanField,
	Form,
	SubFormField,
	SubFormRenderProps,
	TextField,
} from "@hex-insights/forms";
import { MessageFormValues, MessageGroupFormValues } from "../../FormUtilities";
import { MessageForm } from "../Message";
import { BaseFieldProps } from "../shared";
import { UserSelectField } from "../User";
import { UserGroupSelectField } from "../UserGroup";

/**
 * Generic props for fields of the MessageGroup model.
 */
type FieldProps<K extends keyof MessageGroupFormValues.Base = keyof MessageGroupFormValues.Base> = BaseFieldProps<
	Pick<MessageGroupFormValues.Base, K>
>;

/**
 * Generic props for fields of the MessageGroup model that only appear in the create form.
 */
type CreateFieldProps<K extends keyof MessageGroupFormValues.Create = keyof MessageGroupFormValues.Create> =
	BaseFieldProps<Pick<MessageGroupFormValues.Create, K>>;

/**
 * Field component for the `customName` field of the MessageGroup model.
 */
export function CustomName({ formState, ...props }: FieldProps<"customName">) {
	return <TextField formState={formState} name="customName" optional {...props} />;
}

/**
 * Field component for the `isOneOnOne` field of the MessageGroup model.
 */
export function IsOneOnOne({ formState, ...props }: FieldProps<"isOneOnOne">) {
	return <BooleanField formState={formState} name="isOneOnOne" {...props} />;
}

export namespace Messages {
	/**
	 * SubForm field component for the `messages` edge of the MessageGroup model.
	 */
	export function SubForm({ formState, ...props }: CreateFieldProps<"messages">) {
		return (
			<SubFormField
				formState={formState}
				name="messages"
				blankItem={MessageFormValues.blankItemInMessageGroup}
				{...props}
			>
				{SubForm.SubForm}
				{SubForm.AddButton}
			</SubFormField>
		);
	}

	SubForm.SubForm = function ({
		formState,
		onRemoveClick,
	}: SubFormRenderProps<MessageFormValues.CreateInMessageGroup>) {
		return (
			<Form.Column>
				<Button variant="tertiary" size="small" onClick={onRemoveClick} disabled={formState.disabled}>
					Remove Message
				</Button>
				<MessageForm.CreateFieldsInMessageGroup formState={formState} />
			</Form.Column>
		);
	};

	SubForm.AddButton = function ({
		onClick,
		disabled,
	}: AddSubFormButtonRenderProps<
		Pick<MessageGroupFormValues.Create, "messages">,
		MessageFormValues.CreateInMessageGroup
	>) {
		return (
			<Button variant="tertiary" size="small" onClick={onClick} disabled={disabled}>
				Add Message
			</Button>
		);
	};
}

export namespace UserGroups {
	export type SelectProps = FieldProps<"userGroupIDs"> &
		Omit<UserGroupSelectField.MultiSelectProps<MessageGroupFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `userGroups` edge of the MessageGroup model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <UserGroupSelectField.MultiSelect formState={formState} name="userGroupIDs" {...props} />;
	}
}

export namespace Users {
	export type SelectProps = FieldProps<"userIDs"> &
		Omit<UserSelectField.MultiSelectProps<MessageGroupFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `users` edge of the MessageGroup model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <UserSelectField.MultiSelect formState={formState} name="userIDs" {...props} />;
	}
}
